import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import AuthenticatedRoute from "./component/AuthenticatedRoute";

export default function Routes() {
    return (
        <Switch>
            <AuthenticatedRoute exact path="/">
                <Home />
            </AuthenticatedRoute>
            <Route>
                <NotFound />
            </Route>
        </Switch>
    );
}